import { render, staticRenderFns } from "./place-add.vue?vue&type=template&id=cad81a4e&scoped=true&"
import script from "./place-add.vue?vue&type=script&lang=js&"
export * from "./place-add.vue?vue&type=script&lang=js&"
import style0 from "./place-add.vue?vue&type=style&index=0&id=cad81a4e&scoped=true&lang=css&"
import style1 from "./place-add.vue?vue&type=style&index=1&id=cad81a4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad81a4e",
  null
  
)

export default component.exports